/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { IColumn } from 'types'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import { SubmissionStatus } from 'components/molecules/SubmissionStatus'
import { useTranslateGrade } from 'utils/customHooks/useTranslateGrade'
import { Link } from '@mui/material'

export const useTableModel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [translateGrade, gradeColor] = useTranslateGrade();

  const handleGradeFormat = useCallback(
    (cellValue: string, row: any, index: number) => cellValue ? 
      <span className="grading-circle" style={{ background: gradeColor(parseFloat(cellValue)) }}>{translateGrade(parseFloat(cellValue))}</span> 
      : '',
    [],
  )

  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy') : ''),
    [],
  )

  const handleStatusFormat = useCallback(
    (cellValue: string, row: any) => <SubmissionStatus 
      onClick={() => {navigate(`/student-assignments/edit/${row.id}`)}} 
      status={cellValue}
      grade={parseFloat(row.grade)} />,
    [],
  )

  const handleTitleFormat = useCallback(
    (cellValue: string, row: any) => <Link 
          onClick={() => navigate(`/student-assignments/edit/${row.id}`)} 
          style={{color:'#000',cursor:'pointer'}}>{cellValue}</Link>,
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.course')}`,
      field: 'course',
      width: '25%',
      order: true,
    },
    {
      title: `${t('common.title')}`,
      field: 'title',
      width: '30%',
      order: true,
      format: handleTitleFormat
    },
    {
      title: `${t('common.due-date')}`,
      field: 'due_datetime',
      width: '15%',
      format: handleDateFormat,
    },
    {
      title: `${t('common.grade')}`,
      field: 'grade',
      width: '10%',
      format: handleGradeFormat,
    },
    {
      title: `${t('common.status')}`,
      field: 'submission_status',
      width: '15%',
      format: handleStatusFormat,
    },
  ]

  return columns
}
